import React, { useState, useEffect , useRef } from 'react';
import gsap from 'gsap';

import '../../scss/bet-value-modal.scss'

import customValueIcon from '../../assets/images/custom-value-icon.png'
import customValueIconSelected from '../../assets/images/custom-value-icon-selected.png'
import { deviceMinHeight } from '../../utils/constants';

interface BetAmountProps{
    betValue : number;
    isMobile:boolean;
    setBetValue: (value:number) => void
    showBetValueModalHandler : (show:boolean) => void
}

const BetAmount = (props : BetAmountProps)=>{

    const [betValue , setbetValue] = useState(0);
    const [isOpen , setIsOpen] = useState(false);
    const [formValue , setFormValue] = useState(0);
    const [selectedIndex , setIndex] = useState(0);

    const contentDiv = useRef(null);

    const formValues = [1,5,10,'custom'];

    useEffect(() => {

        if(isOpen)return;


        let isCustomValue = true;
        formValues.forEach((v , i)=>{

            if(props.betValue === v){

                isCustomValue = false;
                setIndex(i);
                return;
            }

        })

        if(isCustomValue){
            setIndex(3);
            setFormValue(props.betValue);
            openForm(true , props.betValue);
        }

        setIsOpen(true);
        setbetValue(props.betValue);
        const background = document.getElementById("background");
        gsap.to(background, {
            duration: 0,
            opacity:0.0
        });
         gsap.to(background, {
            duration: 0.3,
            opacity:0.8
        });
        
    });

    const onBetHandler = (value : number , index : number)=>{

        setbetValue(value);
        setIndex(index);

    }

    const openForm = (open : Boolean , value : number)=>{

        const form = document.getElementById('custom-value-container');
        gsap.to(form, {
            duration: 0.5,
            height:open ? 30 : 0.0,
            onComplete:()=>{
                setFormValue(value);
            }
        }
        )
    }

    const getButtons = ()=>{

        

        return formValues.map((v , i) =>{

            if(v !== 'custom')
                return <p key={v} onClick={()=>{
                    openForm(false , 0);
                    onBetHandler(v as number , i);
                }} className={i === selectedIndex ? "bet-button-selected" : "bet-button"}>${v}</p>
            else
                return <div key={v} onClick={()=>{

                    openForm(true , 0);
                    onBetHandler(props.betValue , i);

                }} className={i === selectedIndex ? "bet-button-selected" : "bet-button"}>
                    <img className="custom-value-icon" alt="custom value" src={i === selectedIndex ? customValueIconSelected : customValueIcon}></img>
                </div>
        });
    }

    const close = ()=>{

        if(selectedIndex === 3 && formValue !== 0)
            props.setBetValue(formValue);
        else
            props.setBetValue(betValue);

        const betModal = document.getElementById('bet-modal')
        gsap.to(betModal, {
            duration: 0.3,
            opacity:0.0,
            onComplete:()=>{
                props.showBetValueModalHandler(false);
            }
        })
    }
    
    const onFormChange = (evt : React.ChangeEvent<HTMLInputElement>)=>{
        console.log(evt.target.value)

        if(isNaN(parseFloat(evt.target.value)))
            setFormValue(0);
        else
            setFormValue(parseFloat(evt.target.value));
            
    }

    const onFormFocus = (evt : React.FocusEvent<HTMLInputElement>)=>{

        gsap.to(contentDiv.current,
            {
                // marginTop:window.innerHeight < deviceMinHeight ? '5%' : '20%',
                duration:0.5
            })

    }

    const onFormBlur = (evt : React.FocusEvent<HTMLInputElement>)=>{

        gsap.to(contentDiv.current,
            {
                // marginTop:'50%',
                duration:0.5
            })
    }

    const onKeyPressForm = (evt : any)=>{
        
        if (evt.key === `Enter`)
            close();
    }

    return (
        
        <div id="bet-modal" className={props.isMobile ? "bet-modal" : "bet-modal-desktop"}>
            <div ref={contentDiv} className="content">
                <h2>Bet Amount</h2>
                <p className="bet-value">${betValue !== -1 ? betValue : 0}</p>
                <div className="bet-buttons">
                   {getButtons()}
                </div>
                <div id="custom-value-container" className="custom-value-container" >
                    <input className="custom-value" type="text" id="value" name="value" value={formValue} 
                    onFocus={onFormFocus}
                    onBlur={onFormBlur}
                    onChange={onFormChange}
                    onKeyPress={onKeyPressForm}
                    >
                    </input>
                </div>
                <p onClick={close} className="bet-confirm">Confirm</p>
            </div>
            <div onClick={close} id="background" className="background">
            
            </div>
        </div>
    )
    
}

export default BetAmount;